// Generated by OrchestKit Claude Plugin
// Created: 2026-09-14

import type { Tableau } from './types.ts';

/**
 * Convertit en nombre ce que l'API annonce comme tel.
 *
 * Le pilote PostgreSQL rend les `BIGINT` et `NUMERIC` en CHAÎNES : les types
 * déclarés disent `number`, le réseau livre `"125000"`. Additionner sans
 * convertir concatène — « 0125000 » au lieu de 125 000.
 */
export function enNombre(valeur: unknown): number {
  const nombre = Number(valeur ?? 0);
  return Number.isFinite(nombre) ? nombre : 0;
}

/** Une `DATE` arrive en chaîne OU en objet `Date` selon le pilote. */
function enTexte(valeur: unknown): string {
  return valeur instanceof Date ? valeur.toISOString() : String(valeur);
}

/** Le jour précédant `date` dans la série, s'il y a eu des ventes. */
export function veille(
  serie: NonNullable<Tableau['serie_journaliere']>,
  date: string,
): { montant: number; nombre: number } | undefined {
  const jour = new Date(`${date}T12:00:00`);
  jour.setDate(jour.getDate() - 1);
  const cle = jour.toISOString().slice(0, 10);

  const point = serie.find((ligne) => enTexte(ligne.jour).slice(0, 10) === cle);
  return point === undefined
    ? undefined
    : { montant: enNombre(point.montant), nombre: enNombre(point.nombre) };
}

/**
 * Variation en pourcentage, arrondie à l'unité.
 *
 * `null` quand la veille est à zéro ou inconnue : « +∞ % » ne dit rien, et
 * « +100 % » serait faux.
 */
export function evolution(
  aujourdhui: number,
  precedent: number | undefined,
): number | null {
  if (precedent === undefined || precedent === 0) return null;
  return Math.round(((aujourdhui - precedent) * 100) / precedent);
}

export function dateLongue(date: string): string {
  return new Date(`${date}T12:00:00`).toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function initiales(texte: string): string {
  return texte
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((mot) => mot.charAt(0).toUpperCase())
    .join('');
}
